export default "<div class=\"container-fluid\">\n  <analytics-component></analytics-component>\n</div>\n";